"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'Loading',
  color: {
    primary: {
      v100: '#D6D6D6',
      v200: '#C9C9C9',
      v300: '#B4B4B4',
      v400: '#969696',
      v500: '#666666',
      v600: '#333333',
      v700: '#000000'
    },
    secondary: {
      v100: '#D6D6D6',
      v200: '#C9C9C9',
      v300: '#B4B4B4'
    },
    neutral: {
      v000: '#000000',
      v100: '#ffffff',
      v200: '#F4F8FA',
      v300: '#D9DDE9',
      v400: '#AAB1C7',
      v500: '#757989'
    },
    validation: {
      warning: '#B4B4B4',
      success: '#B4B4B4',
      error: '#B4B4B4'
    }
  }
};